export const bankNumber = '000000';
export const targetGroupId = '10000';